export class LocalStorageManager<T> {
  private readonly key: string;

  constructor(key: string) {
    this.key = key;
  }

  private checkStorageAvailability(): boolean {
    try {
      if (typeof window === 'undefined' || !window.localStorage) {
        return false;
      }

      const testKey = '__storage_test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  public get(): T | null {
    if (!this.checkStorageAvailability()) {
      console.warn(`LocalStorage not available. Cannot get "${this.key}"`);
      return null;
    }

    try {
      const item = localStorage.getItem(this.key);
      return item ? (JSON.parse(item) as T) : null;
    } catch (error) {
      console.error(`Error parsing storage item "${this.key}":`, error);
      return null;
    }
  }

  public set(value: T): boolean {
    if (!this.checkStorageAvailability()) {
      console.warn(`LocalStorage not available. Cannot set "${this.key}"`);
      return false;
    }

    try {
      localStorage.setItem(this.key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error(`Error setting storage item "${this.key}":`, error);
      return false;
    }
  }

  public remove(): boolean {
    if (!this.checkStorageAvailability()) {
      console.warn(`LocalStorage not available. Cannot remove "${this.key}"`);
      return false;
    }

    try {
      localStorage.removeItem(this.key);
      return true;
    } catch (error) {
      console.error(`Error removing storage item "${this.key}":`, error);
      return false;
    }
  }
}
